<template>
  <div class="flow-node" :style="styles">
    <div
      class="flow-node-container"
      :class="isOpen && data.children ? 'flow-node-open' : ''"
    >
      <div class="flow-node-main">
        <div class="left">
          <div class="left-line"></div>
          <div class="left-node"><img :src="nodeImg" /></div>
        </div>
        <div :class="parent ? 'right-container-children' : 'right-container'">
          <div class="main">
            <div>
              <en-user-logo
                v-if="!isBranch"
                class="right-icon"
                size="40px"
                :userName="data.name"
                :imageUrl="data.userLogo"
              ></en-user-logo>
              <div
                v-else
                class="right-icon"
                style="
                  width: 40px;
                  height: 40px;
                  background: #f7bf28;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  style="width: 20px; height: 20px"
                  src="../../assets/并签.png"
                />
              </div>
              <div class="right-name">
                {{ isBranch ? data.nodeName : data.name }}
              </div>
              <div class="right-detail">
                {{ isBranch ? '分支开始到分支结束' : data.nodeName }}
              </div>
              <div
                class="right-date"
                v-if="
                  data.isSupplyApproval === '0' ||
                  !(
                    !data.status ||
                    data.status === '000' ||
                    data.status === '002' ||
                    data.status === '003' ||
                    data.status === '004'
                  )
                "
              >
                {{ data.modifyTime }}
              </div>
              <div class="right-idea">
                {{
                  data.approvalComment &&
                  data.approvalComment.indexOf('[img]') === -1
                    ? data.approvalComment
                    : ''
                }}
              </div>
              <div class="right-btn" @click="open" v-if="isBranch">
                <i
                  :class="isOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                  style="color: #179eda"
                ></i>
              </div>
            </div>
          </div>
          <div class="branch" v-if="isBranch && isOpen && data.children">
            <flow-node
              v-for="(node, index) in data.children"
              :key="index"
              :data="node"
              :info="info"
              :parent="data"
            >
            </flow-node>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enUserLogo from '../en-user-logo'

export default {
  name: 'flow-node',
  props: ['data', 'styles', 'info', 'parent'],
  components: { enUserLogo },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    isBranch() {
      return this.data.pattern === '006'
    },
    nodeImg() {
      let status = {
        '000': '提交',
        '001': '待处理',
        '002': '审批中',
        '003': '已审批',
        '004': '退回',
        '005': '收回',
        '006': '已终止',
      }
      let str = status[this.data.imgFlag]
        ? status[this.data.imgFlag]
        : status['000']
      return require('../../assets/' + str + '.png')
    },
  },
  methods: {
    open() {
      if (this.isOpen) {
        this.isOpen = false
      } else {
        this.info.queryFlowBranchDetail(this.data, () => {
          this.isOpen = true
        })
      }
    },
  },
}
</script>

<style lang="scss">
.flow-node {
  .flow-node-main {
    display: flex;
    justify-content: space-between;
    align-content: center;
    .left {
      display: flex;
      position: relative;
      width: 56px;
      align-items: center;
      justify-content: center;
      .left-line {
        position: absolute;
        z-index: 0;
        left: 28px;
        top: 0px;
        width: 1px;
        height: 100%;
        background: #000000;
        opacity: 0.05;
      }
      .left-node {
        z-index: 1;
      }
    }
    .right-container {
      flex: 1;
      background: #fbfbfb;
      border: 1px solid #f3f3f3;
      border-radius: 4px;
      margin-bottom: 10px;
    }

    .main {
      width: 100%;
      height: 80px;
      position: relative;
      font-weight: 400;
      .right-icon {
        position: absolute;
        left: 20px;
        top: 20px;
      }
      .right-name {
        position: absolute;
        left: 78px;
        top: 21px;
        font-size: 14px;
        color: #000000;
      }
      .right-idea {
        position: absolute;
        font-size: 12px;
        top: 47px;
        right: 20px;
        color: #606060;
      }
      .right-detail {
        position: absolute;
        left: 78px;
        top: 49px;
        font-size: 12px;
        color: #606060;
        line-height: 24px;
      }
      .right-btn {
        position: absolute;
        top: 47px;
        right: 23px;
      }
      .right-date {
        position: absolute;
        top: 21px;
        right: 20px;
        font-size: 12px;
        color: #aeaeae;
      }
    }
  }
  .flow-node-open {
    background: #fbfbfb;
    border-radius: 4px;
    .right-container {
      margin-bottom: 20px;
    }
  }

  .right-container-children {
    flex: 1;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 0;
    background: #fff;
  }

  .branch {
    margin-left: 20px;
    margin-right: 20px;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-right: 15px;
    background: #fff;
    border: 1px solid #f3f3f3;
    border-radius: 4px;
    margin-bottom: 10px;
  }
}
</style>